export enum WagonStaysArea {
    wagonStaysTable = 'wagonStaysTable',
}

export enum WagonStaysAction {
    tableResetClicked = 'tableResetClicked',
    tableFilterApplied = 'tableFilterApplied',
    tableFilterReset = 'tableFilterReset',
    tableFilterSorted = 'tableFilterSorted',
    wagonNumberClicked = 'wagonNumberClicked',
}
